import { CartAddEvent } from '@theme/events';

let activeGallery;
const mobile = window.matchMedia('(max-width: 749px)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function charmTransform(dialog, charm) {
  const modal = dialog.getBoundingClientRect();
  if (!charm || modal.width <= 0 || modal.height <= 0) return 'scale(0.96)';
  const dx = charm.left + charm.width / 2 - (modal.left + modal.width / 2);
  const dy = charm.top + charm.height / 2 - (modal.top + modal.height / 2);
  const sx = Math.max(0.04, Math.min(1, charm.width / modal.width));
  const sy = Math.max(0.04, Math.min(1, charm.height / modal.height));
  return `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
}

document.addEventListener('click', (event) => {
  if (!mobile.matches || !(event.target instanceof Element)) return;
  const label = event.target.closest('.variant-option__button-label--has-swatch');
  const picker = label?.closest('variant-picker, swatches-variant-picker-component');
  const template = picker?.querySelector('template[data-swatch-gallery]');
  const input = label?.querySelector('input[type="radio"]');
  if (!template || !input || input.dataset.connectedProductUrl) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const charm = label.querySelector('.swatch') || label;
  const charmRect = charm.getBoundingClientRect();
  activeGallery?.close();
  const dialog = template.content.querySelector('dialog').cloneNode(true);
  document.body.append(dialog);
  activeGallery = dialog;
  const track = dialog.querySelector('.swatch-gallery__track');
  const slides = [...track.children];
  const prev = dialog.querySelector('[data-gallery-prev]');
  const next = dialog.querySelector('[data-gallery-next]');
  const position = dialog.querySelector('[data-gallery-position]');
  const status = dialog.querySelector('[data-gallery-status]');
  let animation;
  let closePromise;
  const closeGallery = () => {
    if (closePromise) return closePromise;
    if (!dialog.open) return Promise.resolve();
    if (reducedMotion.matches || !dialog.animate) {
      dialog.close();
      return Promise.resolve();
    }
    const currentStyle = getComputedStyle(dialog);
    const start = { transform: currentStyle.transform, opacity: currentStyle.opacity };
    animation?.cancel();
    dialog.dataset.closing = 'true';
    const currentCharm = charm.isConnected ? charm.getBoundingClientRect() : charmRect;
    const visibleCharm = currentCharm && currentCharm.bottom > 0 && currentCharm.top < window.innerHeight ? currentCharm : null;
    animation = dialog.animate([start, { transform: charmTransform(dialog, visibleCharm), opacity: 0 }], {
      duration: 220,
      easing: 'cubic-bezier(0.4, 0, 1, 1)',
      fill: 'forwards'
    });
    closePromise = animation.finished.catch(() => {}).then(() => {
      if (dialog.open) dialog.close();
    });
    return closePromise;
  };
  let index = slides.findIndex((slide) => slide.dataset.variantId === input.dataset.variantId);
  if (index < 0) {
    const optionIndex = Number(input.dataset.inputId?.split('-')[0]) - 1;
    index = slides.findIndex((slide) => JSON.parse(slide.dataset.optionValues)[optionIndex] === input.value);
  }
  index = Math.max(0, index);
  const announce = () => {
    position.textContent = position.dataset.format.replace('[current]', String(index + 1)).replace('[total]', String(slides.length));
    prev.disabled = index === 0;
    next.disabled = index === slides.length - 1;
    slides.forEach((slide, i) => { slide.inert = i !== index; });
  };
  const go = (target) => {
    index = Math.max(0, Math.min(slides.length - 1, target));
    track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'instant' });
    announce();
  };
  dialog.querySelector('[data-gallery-close]').addEventListener('click', closeGallery);
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); closeGallery(); });
  dialog.addEventListener('click', (e) => { if (e.target === dialog) { const b = dialog.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) closeGallery(); } });
  dialog.addEventListener('close', () => {
    dialog.remove();
    animation?.cancel();
    if (activeGallery === dialog) activeGallery = undefined;
    if (label.isConnected && !activeGallery && !document.querySelector('dialog[open]')) input.focus({ preventScroll: true });
  }, { once: true });
  prev.addEventListener('click', () => go(index - 1));
  next.addEventListener('click', () => go(index + 1));
  track.addEventListener('scroll', () => {
    const bounds = track.getBoundingClientRect();
    index = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - bounds.left) < Math.abs(slides[best].getBoundingClientRect().left - bounds.left) ? i : best, 0);
    announce();
  }, { passive: true });
  track.addEventListener('keydown', (e) => {
    if (e.target !== track) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1)); }
  });
  dialog.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-gallery-form]')) return;
    e.preventDefault();
    if (dialog.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    const original = button.textContent;
    dialog.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = status.dataset.adding;
    status.textContent = '';
    const data = new FormData(form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))].slice(0, 5);
    if (sections.length) data.set('sections', sections.join(','));
    data.set('sections_url', window.location.pathname);
    try {
      const response = await fetch(form.action.replace(/\.js$/, '') + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || status.dataset.error);
      status.textContent = status.dataset.added;
      const drawer = document.querySelector('cart-drawer-component[auto-open]');
      if (drawer) await closeGallery();
      document.dispatchEvent(new CartAddEvent(result, 'mobile-swatch-gallery', { source: 'product-form-component', productId: dialog.dataset.productId, variantId: String(data.get('id')), sections: result.sections, itemCount: Number(data.get('quantity')) }));
    } catch (error) {
      status.textContent = error.message || status.dataset.error;
    } finally {
      dialog.dataset.busy = 'false';
      button.disabled = false;
      button.textContent = original;
    }
  });
  dialog.showModal();
  go(index);
  if (!reducedMotion.matches && dialog.animate) {
    animation = dialog.animate([
      { transform: charmTransform(dialog, charmRect), opacity: 0 },
      { transform: 'none', opacity: 1 }
    ], { duration: 340, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
  }
  if (!input.checked) {
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}, true);

mobile.addEventListener('change', () => { if (!mobile.matches) activeGallery?.close(); });
document.addEventListener('shopify:section:unload', () => activeGallery?.close());
reducedMotion.addEventListener('change', () => {
  if (reducedMotion.matches && activeGallery) {
    activeGallery.getAnimations().forEach((animation) => animation.cancel());
  }
});
